import Alert from "@material-ui/lab/Alert";
import React from "react";
import PageSpinner from "../../../../../elements/spinner/PageSpinner";
import DefaultButton from "../../../../../styles/materialButtonStyle";

import { StyledDocumentTitle } from "../../../../../styles/styledTextDocument";
import { StyledConnectionList } from "../../../../../services/styledServiceDetails";

const DialogConnectionsList = ({ t, connections, handleCopy, handleClearCopy, copyId }) => {

  if (!connections) {
    return <PageSpinner
      position="center"
      pt="60"
      pb="60"
    />;
  }

  if (!connections.length) {
    return <Alert severity="warning">
      {t("details.connections.noConnections")}
    </Alert>;
  }

  return (
    <StyledConnectionList>
      <StyledDocumentTitle
        as="h2"
        size="18"
      >
        {t("details.connections.existingConnections")}
      </StyledDocumentTitle>

      <div className="connections">
        {connections.map((connection, key) => (
          <div
            className="connections__row"
            key={key}
          >
            <div>
              <div className="connections__project">
                {connection.project.name}
              </div>
              <div className="connections__name">
                {connection.name}
              </div>
              <div className="connections__client">
                {connection.project.user.email}
              </div>
            </div>
            <div className="connections__action">
              {connection.id === copyId ? <DefaultButton
                  color="transparent"
                  border="danger"
                  onClick={() => { handleClearCopy(); }}
                >
                  <span className="icon-light-cancel" />
                </DefaultButton> :
                <DefaultButton
                  color="transparent"
                  border="success"
                  onClick={() => { handleCopy(connection.id); }}
                >
                  <span className="icon-light-copy" />
                </DefaultButton>
              }
            </div>
          </div>
        ))}
      </div>
    </StyledConnectionList>
  );
};

export default DialogConnectionsList;